import { render, staticRenderFns } from "./bottomBox.vue?vue&type=template&id=56abdd4e&scoped=true&"
import script from "./bottomBox.vue?vue&type=script&lang=js&"
export * from "./bottomBox.vue?vue&type=script&lang=js&"
import style0 from "./bottomBox.vue?vue&type=style&index=0&id=56abdd4e&prod&scoped=true&lang=less&"
import style1 from "./bottomBox.vue?vue&type=style&index=1&id=56abdd4e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56abdd4e",
  null
  
)

export default component.exports